import AwClickableTitle from 'viewmodel/AwClickableTitleViewModel';
import AwIcon from 'viewmodel/AwIconViewModel';

export const searchHistoryCellRenderFunction = (props) => {
    let { item, vmo } = props; //Assume item is ViewModelObject (VMO)

    if (!item) {
        item = vmo;
    }

    if (!item) {
        return null;
    }

    return (
        <div className='sw-row search-history-cell'>
            <AwIcon iconId={item.iconId} className={'search-commands-svg'}></AwIcon>
            <div className='sw-column'>
                <AwClickableTitle title={item.cellHeader1} cellTitleId='CellTitle' source='list' vmo={item}></AwClickableTitle>
                <span className={'search-commands-category'}><em>{item.categoryUi}</em></span>
            </div>
        </div>
    );
};
